import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

// Settings page now redirects to Account page which contains all settings
export default function Settings() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    // Map old settings tabs to account tabs
    const tab = searchParams.get('tab');
    let accountTab = 'settings';
    
    if (tab === 'notifications') accountTab = 'settings';
    if (tab === 'integrations') accountTab = 'integrations';
    if (tab === 'preferences') accountTab = 'settings';
    if (tab === 'support') accountTab = 'help';
    if (tab === 'privacy') accountTab = 'privacy';
    if (tab === 'profile') accountTab = 'profile';
    
    navigate(`/account?tab=${accountTab}`, { replace: true });
  }, [navigate, searchParams]);

  return null;
}
